export default __webpack_public_path__ + "static/media/blog.a8179653.jpg";